import React, { type ReactNode, useRef } from 'react';

import { gsap } from 'gsap';

import './Magnetism.scss';

interface YatMagnetismProps {
    children: ReactNode;
    classes?: string;
}

export const YatMagnetism = ({ children, classes = '' }: YatMagnetismProps) => {
    const isTouch = window.matchMedia('(hover: none)').matches;
    const magneticElement = useRef() as React.MutableRefObject<HTMLDivElement>;

    const onMouseMove = (e) => {
        const centerX = magneticElement.current.getBoundingClientRect().left + magneticElement.current.clientWidth / 2;
        const centerY = magneticElement.current.getBoundingClientRect().top + magneticElement.current.clientHeight / 2;

        const deltaX = Math.floor(centerX - e.clientX) * -0.8;
        const deltaY = Math.floor(centerY - e.clientY) * -0.8;

        gsap.to(magneticElement.current, {
            x: deltaX,
            y: deltaY,
            duration: 0.75,
            ease: 'power2.out',
        });
    };

    const onMouseLeave = () => {
        gsap.to(magneticElement.current, {
            y: 0,
            x: 0,
            duration: 1.25,
            ease: 'elastic.out(1, 0.3)',
        });
    };

    return (
        <div
            className={`yat-magnetism ${classes}`}
            onMouseMove={isTouch ? undefined : onMouseMove}
            onMouseLeave={isTouch ? undefined : onMouseLeave}
        >
            <div ref={magneticElement} className="yat-magnetism__element">
                {children}
            </div>
        </div>
    );
};
